<div class="row">
  <div class="col-md-7 col-lg-12 col-xxl-7">
    <sb-card>
      <div card-body>
        <div class="row mb-4">
          <div class="col-md-5">
            <div class="header-wrapper" style="position: relative;">
              <div class="userPicEdit userPicEditFar cursor-pointer" (click)="pickAmbiance()">
                <sb-icon class="icon-center" icon="edit"></sb-icon>
              </div>
              <img style="object-fit: cover; height: auto; width: 100%;" [src]="ambianceUrl"
                   alt="./assets/img/channel-placeholder.png" />
            </div>
          </div>
          <div class="col-md-7">
            <div class="p-4">
              <h2 class="mb-3">{{ product?.name ? product?.name : ('lang.globals.noValue' | translate) }}</h2>
              <h5>{{ product?.identifier ? product?.identifier : '' }}</h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>PLU</h5>
              <span class="text-muted">{{ product?.plu ? product?.plu : ('lang.globals.noValue' | translate) }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>GTIN</h5>
              <span class="text-muted">{{ product?.gtin ? product?.gtin : ('lang.globals.noValue' | translate) }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>GTIN Representation</h5>
              <span
                class="text-muted">{{ product?.gtinRepresentation ? product?.gtinRepresentation : ('lang.globals.noValue' | translate) }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="mb-3 d-flex flex-column">
              <h5>ASIN</h5>
              <span class="text-muted">{{ product?.asin ? product?.asin : ('lang.globals.noValue' | translate) }}</span>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-md-5 col-lg-12 col-xxl-5">
    <sb-card>
      <div card-header classes="no-border">
        <h3>{{ 'lang.globals.productCategory' | translate }}</h3>
      </div>
      <div card-header-more>
      </div>
      <div card-body>
        <table class="table content-table">
          <thead>
          <tr>
            <th>{{ 'lang.globals.productCategory' | translate }} / {{ 'lang.globals.id' | translate }}</th>
            <th class="text-end">{{ 'lang.globals.modifiedAt' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let ele of product?.categories">
            <tr>
              <td>
                <sb-comp-image-name-wrapper [image]="ele?.illustration?.url">
                  <span firstLine>{{ ele?.name }}</span>
                  <span secondLine>{{ ele?.id }}</span>
                </sb-comp-image-name-wrapper>
              </td>
              <td class="text-end" style="padding-right: 1.8rem!important;">
                <sb-comp-display-modified [data]="ele"></sb-comp-display-modified>
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </div>
    </sb-card>
  </div>
</div>
<ng-container *sbPageAction>
  <a [queryParams]="{returnTo: this.util.getPageLink()}"
     [sbRouterLink]="util.RoutingID.productEdit" [pathParams]="[{id:'productID', value: productId}]">
    <button class="btn btn-secondary">
      <sb-icon icon="edit" class="mr-1"></sb-icon>
      {{ 'lang.globals.edit' | translate }}
    </button>
  </a>
</ng-container>
